import React from "react";
import { Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../core/data/redux/store"; // Replace this with your actual RootState

const AuthFeature = () => {
  // Access the authentication status from Redux state
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  // If the user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
};

export default AuthFeature;
